export const categories = [
  { slug: 'hongtao', name: '红桃视频', icon: 'ri-heart-line', description: '精选高清内容，流畅不缓冲', color: 'bg-red-500' },
  { slug: 'xigua', name: '西瓜视频', icon: 'ri-water-flash-line', description: '海量资源免费观看', color: 'bg-green-500' },
  { slug: 'xiaolan', name: '小蓝视频', icon: 'ri-bubble-chart-line', description: '最新热门视频聚合', color: 'bg-cyan-500' },
  { slug: 'qiezi', name: '茄子视频', icon: 'ri-plant-line', description: '高清全集一站畅享', color: 'bg-purple-500' },
  { slug: 'jiujiu', name: '久久视频', icon: 'ri-time-line', description: '经典资源永久收藏', color: 'bg-orange-500' },
  { slug: 'mangguo', name: '芒果视频', icon: 'ri-sun-line', description: '热门综艺独家放送', color: 'bg-yellow-500' },
];

export const featuredCategories = [
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'new', name: '最新上线', icon: 'ri-rocket-line' },
  { slug: 'top', name: '排行榜', icon: 'ri-trophy-line' },
];